import { createElement } from "@wordpress/element";

/**
 * WordPress dependencies
 */
import { __ } from '@wordpress/i18n';
import { RichText, useBlockProps } from '@wordpress/block-editor';
export default function CodeEdit(_ref) {
  let {
    attributes,
    setAttributes,
    onRemove
  } = _ref;
  const blockProps = useBlockProps();
  return createElement("pre", blockProps, createElement(RichText, {
    tagName: "code",
    value: attributes.content,
    onChange: content => setAttributes({
      content
    }),
    onRemove: onRemove,
    placeholder: __('Write code…'),
    "aria-label": __('Code'),
    preserveWhiteSpace: true,
    __unstablePastePlainText: true
  }));
}
//# sourceMappingURL=edit.js.map